/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Physics14Inputs */

const en__field__enum_primarystudyinterest_study_physics14 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Physics14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physics`)
};

const de__field__enum_primarystudyinterest_study_physics14 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Physics14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physik`)
};

/**
* | output |
* | --- |
* | "Physics" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Physics14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_physics14 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Physics14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Physics14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_physics14(inputs)
	return de__field__enum_primarystudyinterest_study_physics14(inputs)
});
export { _field__enum_primarystudyinterest_study_physics14 as "_field__enum_primaryStudyInterest_STUDY_PHYSICS" }